// extracted by mini-css-extract-plugin
export var conversationListItem = "_wk-2";
export var fullBleedList = "_wk-3";
export var messageText = "_wk-1";
export var previewText = "_wk-0";